import React from 'react';
import {
    AppRecommendationTipNotificationDto
} from '@src/dtos/notification.dto';
import { observer } from 'mobx-react-lite';
import { useStores } from '../../../store';
import { EventType } from '@src/dtos/analytics.dto';

interface TipNotificationProps {
    notification: AppRecommendationTipNotificationDto;
}

const TipNotification: React.FC<TipNotificationProps> = observer(({ notification }) => {
    const { fwVersionStore, notificationStore } = useStores();

    const showRecommendedModal = () => {
        if (!notification.policyVersionNumber) return;

        fwVersionStore.sendGeneralEvent(EventType.LinkClicked,
            { button: 'viewPolicyUpdateRecommendation', location : 'notification' });

        notificationStore.setNotificationVisible(false);

         fwVersionStore.setRecommendedAppData({
             versionNumber: notification.policyVersionNumber,
             outboundRecommendedApps: notification.outboundRecommendedApps ?? [],
             inboundRecommendedApps: notification.inboundRecommendedApps ?? [],
             shouldDisplay: true
         });
    };

    return <div className="details">
            We have new policy update recommendations for V{notification.policyVersionNumber} to enhance your business protection
                <button type="button" className="link" onClick={showRecommendedModal}>View policy update recommendations</button>
    </div>;
});

export default TipNotification;
